export default {
	forms: {
		edit: {
			config: {
				fields: {
					id: {},
					region: {},
					district: {},
					name: {}
				}
			}
		},
		list: {
			config: {
				fields: {
					id: {
						config: {
							hide: true
						}
					},
					region: {},
					district: {},
					name: {}
				}
			}
		},
		select: {
			panel: {
				width: '80%'
			},
			config: {
				fields: {
					id: {
						config: {
							hide: true
						}
					},
					region: {},
					district: {},
					name: {}
				}
			}
		}
	}
}